import FouExpand from 'components/tools/fou-expand/'
import DOMPurify from 'dompurify'
import WarningTriangleIcon from 'components/icons/warning-triangle/'
export default {
  name: 'uploader-label',

  components: {
    FouExpand,
    WarningTriangleIcon
  },
  props: {
    status: {
      type: String,
      default: 'live'
    }
  },
  computed: {
    uploaderDescription () {
      return DOMPurify.sanitize(this.$t('pages.submissions.components.upload.uploader.description.drandrop'), {
        ADD_ATTR: ['target'],
      })
    }
  }
}
